import SoundManager from "../../../../../lib/html5-software-library/src/ranj/audio/SoundManager";
import SoundManagerEvent from "../../../../../lib/html5-software-library/src/ranj/audio/SoundManagerEvent";
import AbstractCommand from "../../application/AbstractCommand";
import SkinKeyRegistry from "../../ui/SkinKeyRegistry";

export default class InitializeAudioSubtitlesCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {SoundManager} soundManager 
     */
    constructor(dispatcher, soundManager) {
        super(dispatcher);

        this._soundManager = soundManager;

        this._audioSubtitlePopupSkin = null;
        this._handleAudioCueChangedBound = this._handleAudioCueChanged.bind(this);
    }

    execute(evt) {
        this._soundManager.addEventListener(SoundManagerEvent.AUDIO_CUE_CHANGED, this._handleAudioCueChangedBound);
    }

    _handleAudioCueChanged(evt) {
        this._soundManager.removeEventListener(SoundManagerEvent.AUDIO_CUE_CHANGED, this._handleAudioCueChangedBound);

        // Pass in this cue as the mediator for the skin isn't initialized and listening to the audio_cue_changed event yet.
        let initialSubtitleText = '';
        const activeCues = evt.activeCues;
        if (activeCues.length > 0) {
            // Note: It is always showing the first cue active, so if you have overlapping cues, the first cue has to end before showing the newer one.
            initialSubtitleText = activeCues[0].text;
        }

        this._createSkin(initialSubtitleText);
    }

    _createSkin(initialSubtitleText) {
        if (this.isInitialized) {
            return;
        }

        this._audioSubtitlePopupSkin = this.openPopup(SkinKeyRegistry.AUDIO_SUBTITLE_POPUP_SKIN, null, {
            needsOverlay: false,
            priority: 100,
        }, {
            initialSubtitleText,
        });
    }

    get isInitialized() {
        return !!this._audioSubtitlePopupSkin;
    }
}